import { motion } from "framer-motion";

export const ease = [0.22, 1, 0.36, 1];

export function Reveal({ children, className = "", delay = 0, y = 40, as }) {
  const Comp = motion[as || "div"];
  return (
    <Comp
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, ease, delay }}
    >
      {children}
    </Comp>
  );
}

export function Overline({ children, className = "" }) {
  return (
    <span className={`inline-flex items-center gap-3 text-[11px] md:text-xs tracking-[0.25em] uppercase font-semibold text-muted ${className}`}>
      <span className="h-px w-8 bg-sage" />
      {children}
    </span>
  );
}
